import { useDispatch } from "react-redux"
import { Creators as NotificationCreators } from "modules/notifications/model"

export function useNotifications() {
  const dispatch = useDispatch()

  return {
    /**
     * @param {"info" | "warning" | "error" | "success"} level
     * @param {string} title
     * @param {string} message
     */
    add: (level, title, message) => {
      dispatch(NotificationCreators.add(level, title, message))
    },
  }
}
